import { Component, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { FormInputBaseComponent } from '@shared/modules/form-components/base/form-input-base.component';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent extends FormInputBaseComponent<boolean> implements OnInit {
  @Input() checkboxColor: 'blue' | 'red' = 'blue';
  @Input() checked = false;
  @Input() hideLabel: boolean;
  @Input() showDisabled: boolean = false;

  @Input() set isDisabled(value: boolean) {
    this.setDisabledState(value);
  }

  @Output() isChecked: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    @Self()
    @Optional()
    private ngControl: NgControl
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    const superCalled = super.ngOnInit();
    this.control = this.ngControl?.control;
    return superCalled;
  }

  writeValue(value: boolean): void {
    this.checked = value ?? false;
    super.writeValue(value);
  }

  onCheckboxChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    this.isChecked.emit(checked);

    if (this.onChange) {
      this.onChange(checked);
    }

    if (this.onTouched) {
      this.onTouched();
    }

    this.writeValue(checked);
  }
}
